// src/pages/CoveragePage.jsx
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import Layout from '../components/Layout';

export default function CoveragePage() {
  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>Coverage Map</h1>
          <p className="page-subtitle">
            Check if your area is covered by our fixed wireless network
          </p>

          <div className="coverage-page-content">
            <div className="coverage-map-placeholder">
              <div className="coverage-info">
                <FaMapMarkerAlt className="coverage-icon-large" />
                <h3>Coverage Areas in Kisumu</h3>
                <ul>
                  <li>✓ Kisumu CBD</li>
                  <li>✓ Milimani</li>
                  <li>✓ Nyalenda</li>
                  <li>✓ Manyatta</li>
                  <li>✓ Kondele</li>
                  <li>✓ Kibos</li>
                  <li>✓ Kajulu</li>
                  <li>✓ Riat</li>
                </ul>
                <p className="coverage-note">
                  Coverage is expanding. Contact us to check specific locations.
                </p>
              </div>
            </div>

            <div className="coverage-actions-page">
              <h3>Check Your Area</h3>
              <p>Contact us to confirm coverage in your specific location</p>
              <div className="coverage-buttons">
                <Link to="/#contact" className="coverage-btn-primary">
                  <FaEnvelope /> Send Inquiry
                </Link>
                <a href="tel:0730320000" className="coverage-btn-secondary">
                  <FaPhone /> Call Us
                </a>
                <a href="https://wa.me/254730320000" className="coverage-btn-secondary">
                  <FaWhatsapp /> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}